var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconEditContent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "14px",
    viewBox: "0 0 16 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "App",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Blog-section---choose-content",
    transform: "translate(-340.000000, -283.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(324.000000, 270.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-edit-content",
    transform: "translate(16.000000, 13.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.7777778,3.88888889 L14.7777778,11.6666667 C14.7777778,12.5261111 14.0816667,13.2222222 13.2222222,13.2222222",
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 1.55555556,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4444444,11.6666667 L12.4444444,1.55555556 C12.4444444,0.696111111 11.7483333,0 10.8888889,0 L1.55555556,0 C0.696111111,0 0,0.696111111 0,1.55555556 L0,11.6666667 C0,12.9554444 1.04455556,14 2.33333333,14 L13.2222222,14 L13.2222222,12.4444444 C12.7928889,12.4444444 12.4444444,12.0952222 12.4444444,11.6666667 Z M8.55555556,11.6666667 L3.88888889,11.6666667 C3.45955556,11.6666667 3.11111111,11.3182222 3.11111111,10.8888889 L3.11111111,10.8888889 C3.11111111,10.4595556 3.45955556,10.1111111 3.88888889,10.1111111 L8.55555556,10.1111111 C8.98488889,10.1111111 9.33333333,10.4595556 9.33333333,10.8888889 L9.33333333,10.8888889 C9.33333333,11.3182222 8.98488889,11.6666667 8.55555556,11.6666667 Z M8.55555556,8.55555556 L3.88888889,8.55555556 C3.45955556,8.55555556 3.11111111,8.20711111 3.11111111,7.77777778 L3.11111111,7.77777778 C3.11111111,7.34844444 3.45955556,7 3.88888889,7 L8.55555556,7 C8.98488889,7 9.33333333,7.34844444 9.33333333,7.77777778 L9.33333333,7.77777778 C9.33333333,8.20711111 8.98488889,8.55555556 8.55555556,8.55555556 Z M8.55555556,4.66666667 L3.88888889,4.66666667 C3.45955556,4.66666667 3.11111111,4.31822222 3.11111111,3.88888889 L3.11111111,3.11111111 C3.11111111,2.68177778 3.45955556,2.33333333 3.88888889,2.33333333 L8.55555556,2.33333333 C8.98488889,2.33333333 9.33333333,2.68177778 9.33333333,3.11111111 L9.33333333,3.88888889 C9.33333333,4.31822222 8.98488889,4.66666667 8.55555556,4.66666667 Z",
    id: "Shape",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEditContent);
export default __webpack_public_path__ + "static/media/icon-edit-content.b94239365cae91c43eb8ddac37f86041.svg";
export { ForwardRef as ReactComponent };